import type { ReactNode } from "react";

export function SwotReportFilterBar(props: { readonly children?: ReactNode | undefined; readonly label?: string | undefined }) {
  return <section className="swot-report-filter-bar" aria-label={props.label ?? "Filters"}>{props.children}</section>;
}
